import React, { useMemo } from 'react';
import { RawIntlProvider, createIntl, createIntlCache } from 'react-intl';
import en from './en.json';
import es from './es.json';
import ja from './ja.json';
import ru from './ru.json';
import zh from './zh.json';
import it from './it.json';
import de from './de.json';
import fr from './fr.json';
const messageMap = {
    en,
    es,
    ja,
    ru,
    zh,
    it,
    de,
    fr,
};
const cache = createIntlCache();
const Intl = ({ children, locale }) => {
    const intl = useMemo(() => {
        const messages = messageMap[locale];
        return createIntl({
            locale,
            defaultLocale: 'en',
            messages,
        }, cache);
    }, [locale]);
    return (React.createElement(RawIntlProvider, { value: intl },
        React.createElement(React.Fragment, null, children)));
};
export default Intl;
//# sourceMappingURL=index.js.map